import React, { Component, PropTypes } from 'react';
import cn from 'classnames';
import moment from 'moment';
import { Row, Col, Alert, Button, Icon } from 'antd';
import _ from 'lodash';
import { Link } from 'react-router';
import { formatNumber } from 'utils/formatting';
import classes from '../styles/order/OrderInfo.module.scss';

const formatPrice = (number) => {
  return formatNumber(number, '0,0.00');
};

const orderStatuses = {
  pending: 'Pending',
  confirm: 'Confirmed',
  paid: 'Paid',
  success: 'Success',
  rejected: 'Cancelled',
  refunded: 'Refunded',
};

const OrderHeader = ({ orderItem, onOpenRemarkModal, onOpenRefundModal }) => {
  const classroom = orderItem.class;
  const { teacher, student } = orderItem;

  const classRegisterDate = moment(classroom.createdAt).format('DD/MM/YYYY');

  const orderCreatedDate = moment(orderItem.createdAt).format('DD/MM/YYYY HH:mm');

  const birthday = _.get(student, 'birthday');
  const age = moment().diff(moment(birthday), 'years');
  const deliveryInfo = _.get(orderItem, 'order.deliveryInformation');

  return (
    <div className={cn('content-header', classes.headerContainer)}>
      {orderItem.status === 'refunded' && <Alert message="Refunded" type="warning" description={' '} />}
      <Row className={classes.headerContent}>
        <Col xs={24}>
          <Button className={'pull-right'} onClick={onOpenRemarkModal}>
            <Icon type="pushpin" />
            Edit remark
          </Button>
          {/* {orderItem.status === 'paid' && (
            <Button type="danger" onClick={onOpenRefundModal} className={cn('pull-right', classes.marginRightBtn)}>
              Refund
            </Button>
          )} */}

          {<h2>Order Item: {orderItem.code}</h2>}
          {
            <h3>
              Class: <Link to={`/class/${orderItem.class._id}`}>{orderItem.class.name}</Link>
            </h3>
          }
        </Col>
      </Row>
      <Row gutter={12}>
        <Col xs={3}>
          <div className={classes.imageContainer}>
            <img className={cn(classes.profileImage)} src={classroom.coverImage} />
          </div>
        </Col>
        <Col xs={7}>
          <div>
            <span className="bold">Teacher:</span> <Link to={`/teacher/${teacher._id}`}>{teacher.displayName}</Link>
          </div>
          <div>
            <span className="bold">Ref No.: </span>
            <Link to={`/order/${orderItem.order._id}`}>{orderItem.order.refNo}</Link>
          </div>
          <div>
            <span className="bold">Order Date & Time:</span> {orderCreatedDate}
          </div>
        </Col>
        <Col xs={7}>
          <div>
            <span className="bold">Student:</span> <Link to={`/student/${student._id}`}>{`${student.name.first} ${student.name.last}`}</Link>
          </div>
          <div>
            <span className="bold">Age:</span> {age}
          </div>
          <div>
            <span className="bold">Sex:</span> {_.startCase(student.gender)}
          </div>
        </Col>
        <Col xs={7}>
          <div>
            <span className="bold">Status:</span> {orderStatuses[orderItem.status]}
          </div>
          <div>
            <span className="bold">Payment: </span> {orderItem.order.paymentMethod === 'cc' ? 'Credit card' : 'Bank Transfer'}
          </div>
          <div>
            <span className="bold">Com Fee:</span> {orderItem.serviceFee === 0 || orderItem.serviceFee ? formatPrice(orderItem.serviceFee - orderItem.cardFee) : 'n/a'}
          </div>
          <div>
            <span className="bold">%Com Fee: </span> {orderItem.feePercentage || 0}%
          </div>
        </Col>
      </Row>

      {orderItem.remark && (
        <Row>
          <Col xs={24}>
            <span className="bold"> Remark: </span>
            <span className="remark-text">{orderItem.remark}</span>
          </Col>
        </Row>
      )}
      {deliveryInfo && (
        <div>
          <span className="bold">ที่อยู่ในการจัดส่ง:</span>
          <div className="">
            {deliveryInfo.name}
            <br /> {deliveryInfo.address} {deliveryInfo.province} {deliveryInfo.postalCode} Tel. {deliveryInfo.phone}
          </div>
        </div>
      )}
      <div className="padding-bottom-30" />
    </div>
  );
};

export default OrderHeader;
